import { Box, BoxProps, ColorOptions, Icon, Loader, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { observer } from 'mobx-react'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import { ModBox } from '../../../../comps/ModifiedBox/ModifiedBox'
import { staticStrings } from '../../../../data/static/strings'
import { useLazyApiData, useStores } from '../../../../data/store'
import { Routes } from '../../../../nav/routes'
import { useWindowDimensions } from '../../../../util/util'
import { styles } from './styles'

export interface SubMenuProps {
  onSelected: () => void
  hide?: boolean
}

export const renderAlertModal = (): React.ReactElement => {
  return (
    <Box {...styles(1000).alert}>
      <Loader type="large" />
    </Box>
  )
}

const SubMenu: FC<SubMenuProps> = ({ onSelected, hide = false }: SubMenuProps) => {
  const navigation = useNavigation()
  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  const { logout, reset, hasSupersetPermission} = useStores((store) => ({
    logout: store?.user?.session?.logout,
    reset: store?.reset,
    hasSupersetPermission:store?.userManagement?.hasSupersetPermission()
  }))

  const [logoutAPI, { state }] = useLazyApiData(logout)

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      onSelected()
      reset()
      window.set_merchant_details_after_logout?.()
      navigation?.reset({
        index: 0,
        routes: [{ name: Routes.LOGIN }],
      })
    }
  })

  const [isHovering, setIsHovering] = useState({ profile: false, logOut: false })

  if (hide) {
    return null
  }
  // const errorVisible = error.length > 0

  const handleProfilePress = (): void => {
    onSelected()
    return navigation.navigate(Routes.PROFILE)
  }

  const getHoverStyle = (hover: boolean): BoxProps => {
    let hoverStyle = {}
    if (hover) {
      // Todo
      hoverStyle = { backgroundColor: 'LIGHTEST_GREY' as ColorOptions }
    }
    return hoverStyle
  }

  const handleProfileHover = (hovering: boolean): void => {
    setIsHovering({ profile: hovering, logOut: false })
  }

  const handleLogoutHover = (hovering: boolean): void => {
    setIsHovering({ profile: false, logOut: hovering })
  }

  const handleLogout = () => {
    logoutAPI()
  }

  return (
    <Box {...themedStyle.subMenu}>
      <ModalDialog children={renderAlertModal()} show={state === 'pending'} />
      <ModBox show={!hasSupersetPermission} underlayColor="WHITE45" onPress={handleProfilePress} testID="my-profile" onHover={handleProfileHover}>
        <ModBox {...themedStyle.subMenuItem} {...getHoverStyle(isHovering.profile)}>
          <Icon id="USER" color="BLACK" />
          <Spacer size={18} direction="horizontal" />
          <Text color="BLACK" fontSize={12} fontWeight="900">
            {staticStrings.myAccount}
          </Text>
        </ModBox>
      </ModBox>
      <Box underlayColor="WHITE45" testID="logout" onPress={handleLogout} onHover={handleLogoutHover}>
        <Box {...themedStyle.subMenuItem} {...getHoverStyle(isHovering.logOut)}>
          <Icon id="LOCK" color="RED" />
          <Spacer size={18} direction="horizontal" />
          <Text color="RED" fontSize={12} fontWeight="900">
            {staticStrings.logout}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
export default observer(SubMenu)
